import { Component, OnInit } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { Kullanici } from 'src/app/models/kullanici.model';
import { Profil } from 'src/app/models/profil.model';
import { GirisService } from 'src/app/services/giris.service';
import { ProfilService } from 'src/app/services/profil.service';

@Component({
  selector: 'profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.css']
})
export class ProfilComponent implements OnInit {

  constructor(private profilService: ProfilService,private girisService: GirisService) { this.girisService=girisService; }

  kullanici: Kullanici = new Kullanici();
  yukleniyor = false;
  ngOnInit(): void {
    this.kullanici=this.girisService.girisBilgi();
    this.kullaniciGetir();
  }

  profilgelen:Profil=new Profil();
  
  kullaniciGetir() {
    this.yukleniyor=true;
    var tckimliknoint: number = +this.kullanici.tckimlikno;
    this.profilService.getByTCKimlikNo(tckimliknoint).subscribe(res => {
    this.profilgelen=res;
    this.yukleniyor=false;
    });
  }

}
